import { ORM } from 'redux-orm';
import LocationModel from './models/locations';
import DeviceModel from './models/devices';

const orm = new ORM();
orm.register(LocationModel, DeviceModel);

export default orm;
